module.exports = __webpack_public_path__ + "static/SELL_ON_SOLV_video-96e18890ed5b9d938bd14361737e9d6f.mp4";